import { render, staticRenderFns } from "./resource-access-configuration.vue?vue&type=template&id=77e9bf9c&scoped=true&"
import script from "./resource-access-configuration.vue?vue&type=script&lang=ts&"
export * from "./resource-access-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e9bf9c",
  null
  
)

export default component.exports